var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.borrowerWebContent !== undefined)?_c('v-app',[_c('v-main',[_c('router-view')],1),_vm._v(" "),_c('sn-toast',_vm._b({on:{"input":_vm.closeToast,"actionClicked":_vm.toast.actionClicked}},'sn-toast',_vm.toast,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }